import React from 'react'
import PropTypes from 'prop-types'
import ExternalLink from '../external-link'
import { makeMailUrl } from '../../helpers'
import style from './index.module.scss'

const FeedbackButton = ({ emailAddress }) => (
  <ExternalLink
    className={style.FeedbackButton}
    url={makeMailUrl(emailAddress)}
    title="Contact Concierge"
  >
    ?
  </ExternalLink>
)

FeedbackButton.propTypes = {
  emailAddress: PropTypes.string,
}

export default FeedbackButton
